import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";

export default function FilmSection() {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const play = () => {
    const v = videoRef.current;
    if (!v) return;
    const p = v.play();
    if (p) p.catch(() => {});
    setPlaying(true);
  };

  return (
    <section id="film" data-testid="film-section" className="border-y border-gold/15 bg-ink2 py-24 lg:py-36">
      <div className="mx-auto max-w-6xl px-5 sm:px-10 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="mb-12 text-center"
        >
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold/80">THE FILM</p>
          <h2 className="mt-4 font-display text-2xl tracking-tight text-cream sm:text-3xl lg:text-4xl">
            Seventy Seconds of Memory
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-base font-light leading-relaxed text-stone2 sm:text-lg">
            A journey through the courts, churches and wedding halls of the highlands —
            told in the grain of memory, with archival-style imagery.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="group relative border border-gold/25 shadow-[0_20px_50px_rgba(0,0,0,0.8)]"
        >
          <video
            ref={videoRef}
            data-testid="documentary-video"
            poster="/images/history/scene_02.png"
            className="aspect-video w-full object-cover"
            controls={playing}
            preload="metadata"
            playsInline
          >
            <source src="/videos/kabas-history.mp4" type="video/mp4" />
            <source src="/videos/kabas-history.webm" type="video/webm" />
          </video>
          {!playing && (
            <button
              onClick={play}
              data-testid="documentary-play-button"
              className="absolute inset-0 flex cursor-pointer flex-col items-center justify-center gap-6 bg-ink/45 transition-colors duration-500 hover:bg-ink/30"
              aria-label="Play the history of the kaba"
            >
              <span className="flex h-20 w-20 items-center justify-center rounded-full border border-gold/60 bg-ink/60 backdrop-blur-sm transition-transform duration-500 group-hover:scale-110">
                <Play className="ml-1 h-7 w-7 text-gold" fill="currentColor" />
              </span>
              <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-cream/90">
                Watch · The Kaba, 2026
              </span>
            </button>
          )}
        </motion.div>
      </div>
    </section>
  );
}
